import PropTypes from 'prop-types';
import { Container, Alert, AlertTitle } from '@material-ui/core';

RoleBasedGuard.propTypes = {
  module: PropTypes.string,
  children: PropTypes.node
};

export default function RoleBasedGuard({ module, children }) {
  const modulePermissions = window.localStorage.getItem('accessModules');

  if (!modulePermissions?.includes(module)) {
    return (
      <Container>
        <Alert severity="error">
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page
        </Alert>
      </Container>
    );
  }

  if (!modulePermissions && modulePermissions.length === 0) {
    return (
      <Container>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Please contact Admin
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
